<div class="ancillary-flight-bound-selector border white-bg rounded-large" *ngIf="(showFlightCard$ | async) === false">
  <span class="is-vishidden" aria-live="polite">{{
    'ancillaries.journey'
      | finLocalization
        : {
            journeyNumber: activeBoundIndex + 1,
            from: locations[boundsOrFlights[activeBoundIndex].departure.locationCode].cityName,
            to: locations[boundsOrFlights[activeBoundIndex].arrival.locationCode].cityName,
          }
  }}</span>
  <div class="pr-small">
    <fcom-ufo
      [departure]="{
        dateTime:
          (boundsOrFlights[activeBoundIndex].departure.dateTime | finTime) +
          ' ' +
          (boundsOrFlights[activeBoundIndex].departure.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
        city: locations[boundsOrFlights[activeBoundIndex].departure.locationCode].cityName,
        airportCode: boundsOrFlights[activeBoundIndex].departure.locationCode,
        airport: locations[boundsOrFlights[activeBoundIndex].departure.locationCode].name,
      }"
      [arrival]="{
        dateTime:
          (boundsOrFlights[activeBoundIndex].arrival.dateTime | finTime) +
          ' ' +
          (boundsOrFlights[activeBoundIndex].arrival.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
        city: locations[boundsOrFlights[activeBoundIndex].arrival.locationCode].cityName,
        airportCode: boundsOrFlights[activeBoundIndex].arrival.locationCode,
        airport: locations[boundsOrFlights[activeBoundIndex].arrival.locationCode].name,
      }"
      [airlines]="
        $any(boundsOrFlights[activeBoundIndex]).uniqueAirlineNames || [
          $any(boundsOrFlights[activeBoundIndex]).operatingAirline?.name,
        ]
      "
      [stops]="$any(boundsOrFlights[activeBoundIndex]).stops || 0"
      [duration]="boundsOrFlights[activeBoundIndex].duration | finDuration | async"
      [tails]="tails | finMap: boundsOrFlights[activeBoundIndex].id | finTailNames"
      [isByBusOnly]="isBusOnlyConnections | finMap: boundsOrFlights[activeBoundIndex].id"
      [showViewDetails]="true"
      [focusOnViewDetails$]="focusOnDetails$"
      (viewDetails)="viewDetails.emit()"
    />
  </div>

  <div class="border-top pr-small-x ps-xsmall-y flex flex--center">
    <button
      *ngIf="boundsOrFlights.length > 1"
      class="flex--nogrow flex--self-start"
      [title]="
        ($any(boundsOrFlights[activeBoundIndex]).itinerary ? 'actions.previousBound' : 'actions.previousFlight')
          | finLocalization
      "
      (click)="onChangeFlightBound(activeBoundIndex - 1, -1)"
      data-testid="service-selection-prev-segment"
    >
      <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_LEFT" />
    </button>
    <div class="progress flex-1 flex flex--row flex--center">
      <span
        class="progress-dots"
        *ngFor="let bound of boundsOrFlights; index as i"
        [class.active]="i === activeBoundIndex"
      ></span>
    </div>
    <button
      *ngIf="boundsOrFlights.length > 1"
      class="flex--nogrow flex--self-end"
      [title]="
        ($any(boundsOrFlights[activeBoundIndex]).itinerary ? 'actions.nextBound' : 'actions.nextFlight')
          | finLocalization
      "
      (click)="onChangeFlightBound(activeBoundIndex + 1, 1)"
      data-testid="service-selection-next-segment"
    >
      <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_RIGHT" />
    </button>
  </div>
</div>

<fin-flight-card
  *ngIf="(showFlightCard$ | async) === true"
  [flightOrBound]="boundsOrFlights[activeBoundIndex]"
  [title]="
    locations[boundsOrFlights[activeBoundIndex].departure.locationCode].cityName +
    ' - ' +
    locations[boundsOrFlights[activeBoundIndex].arrival.locationCode].cityName
  "
  [locations]="locations"
  [passengers]="passengers"
  [hideModify]="true"
  (viewDetails)="viewDetails.emit()"
>
  <div class="ps-medium-y">
    <div class="ps-medium-t ps-medium-x border-top flex flex--center">
      <fcom-button
        *ngIf="boundsOrFlights.length > 1"
        class="flex--nogrow"
        [text]="'carousel.previous' | finLocalization"
        [aria]="{
          label:
            ($any(boundsOrFlights[activeBoundIndex]).itinerary ? 'actions.previousBound' : 'actions.previousFlight')
            | finLocalization,
        }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [disabled]="activeBoundIndex === 0"
        data-testid="service-selection-prev-segment"
        (clickBtn)="activeBoundIndex !== 0 && onChangeFlightBound(activeBoundIndex - 1, -1)"
      />
      <div class="progress flex-1 flex flex--row flex--center ps-medium-x">
        <span class="rounded-large alert-50-bg ps-xsmall-r ps-xxsmall-y font-body-1 flex flex--wrap flex--center">
          <span class="ps-xsmall-l">{{ 'services.flight' | finLocalization }}</span>
          <span class="ps-xsmall-l">{{ activeBoundIndex + 1 }} / {{ boundsOrFlights.length }}</span>
        </span>
      </div>
      <fcom-button
        *ngIf="boundsOrFlights.length > 1"
        class="flex--nogrow"
        [text]="'carousel.next' | finLocalization"
        [aria]="{
          label:
            ($any(boundsOrFlights[activeBoundIndex]).itinerary ? 'actions.nextBound' : 'actions.nextFlight')
            | finLocalization,
        }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [disabled]="activeBoundIndex === boundsOrFlights.length - 1"
        data-testid="service-selection-next-segment"
        (clickBtn)="activeBoundIndex !== boundsOrFlights.length - 1 && onChangeFlightBound(activeBoundIndex + 1, 1)"
      />
    </div>
  </div>
</fin-flight-card>
